export default function() {
    var table = $('#donors-table').DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            'url': '/datatables/donors',
            'type': 'GET',
            'data': function( p ) {
                console.log(p);
                p.off_code = $('.filter-form [name="off_code_search"]').val();
                p.name = $('.filter-form [name="donor_name"]').val();
                p.surname = $('.filter-form [name="donor_surname"]').val();
                p.email = $('.filter-form [name="donor_email"]').val();
                p.donated = $('.filter-form [name="donor_donated"]').val();
                p.start_date = $('.filter-form [name="start_date"]').val();
                p.end_date = $('.filter-form [name="end_date"]').val();
            },
            "dataSrc": function(json) {
                $('.loader-container').addClass('d-none');
                return json.data;
            }
        },
        columns: [
            {name: 'action', data: 'action', width: '20%'},
            {name: 'off_codice', data: 'Off_Codice' ,width: '20%', class:'text-end'},
            {name: 'Off_Ana1', data: 'Off_Ana1', width: '20%'},
            {name: 'Off_Ana2', data: 'Off_Ana2', width: '20%'},
            {name: 'total_donated', data: 'total_donated', width: '20%'}
        ],
        language: {
            "sLengthMenu": "_MENU_ Donatori per pagina",
            "sZeroRecords": "Nessun Donatore",
            "sInfo": "Mostra da _START_ a _END_ di _TOTAL_ Donatori",
            "sInfoEmpty": "0 di 0 su 0 Donatori",
            "sInfoFiltered": "(Filtrati _MAX_ Donatori)",
            "sInfoPostFix": "",
            "sSearch": "Cerca",
            "oPaginate": {
                "sFirst":    "Inizio",
                "sPrevious": "Indietro",
                "sNext":     "Avanti",
                "sLast":     "Fine"
            }
            
        },
        searching: false,
    });
    $('#start_search').on('click', function(e) {
        e.preventDefault();  // Evita il comportamento predefinito
        
        console.log('Search clicked');
        
        // Mostra la loader
        $('.loader-container').removeClass('d-none');
        
        // Cattura i valori dei filtri
        var filters = {
            off_code_search: $('[name="off_code_search"]').val(),
            donor_name: $('[name="donor_name"]').val(),
            donor_surname: $('[name="donor_surname"]').val(),
            donor_email: $('[name="donor_email"]').val(),
            donor_donated: $('[name="donor_donated"]').val(),
            start_date: $('[name="start_date"]').val(),
            end_date: $('[name="end_date"]').val(),
        };
        
        // Aggiungi i filtri all'URL della richiesta
        var url = '/datatables/donors?' + $.param(filters);
        
        console.log("URL with filters: ", url);  // Log per debug
        
        // Aggiorna la URL e ricarica la tabella con i filtri
        table.ajax.url(url).load(function() {
            // Puoi aggiungere qualsiasi azione che desideri dopo il caricamento dei dati
            $('.loader-container').addClass('d-none');  // Nasconde il loader
        });
    });
    
    $(document).on('click', '.refresh-all-filter', function() {
        // Resetta i valori dei filtri
        $('[name="off_code_search"]').val('');
        $('[name="donor_name"]').val('');
        $('[name="donor_surname"]').val('');
        $('[name="donor_email"]').val('');
        $('[name="donor_donated"]').val('');
        $('[name="start_date"]').val('');
        $('[name="end_date"]').val('');
    
        // Log per il debug
        console.log("Filters reset, reloading table...");
    
        // Ricarica la tabella senza filtri, senza parametri
        table.ajax.url('/datatables/donors').load(function() {
            // Puoi aggiungere qualsiasi azione che desideri dopo il caricamento dei dati
            $('.loader-container').addClass('d-none');  // Nasconde il loader
        });
    });
}